import { createDate } from './create-date';
/**
 * A function returning the first date of the month.
 *
 * @param date - The initial date.
 * @returns - The first date of the initial date month.
 *
 * @example
 * ```ts-no-run
 * firstDayOfMonth(new Date(2016, 0, 15)); // 2016-01-01
 * ```
 */
export var firstDayOfMonth = function (date) {
    return createDate(date.getFullYear(), date.getMonth(), 1);
};



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-date-math/dist/es/first-day-of-month.js
// module id = ../../../../@progress/kendo-date-math/dist/es/first-day-of-month.js
// module chunks = 3